module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/organization/organization-show/organization-show.component.scss
// module id = ./src/app/views/setting/organization/organization-show/organization-show.component.scss
// module chunks = main